import { createFileRoute } from "@tanstack/react-router";
import { AccommodationPage } from "../../components/participant/accommodation-page";

/** `/me/accommodation` — the participant's own room (any card; the API answers only their own beds). */
export const Route = createFileRoute("/_app/me/accommodation")({
	component: AccommodationPage,
});
